<form class="g-3 needs-validation" name="CompanyForm" (ngSubmit)="CompanyValidate(CompanyForm)" #CompanyForm="ngForm"
    novalidate>
    <div class="card">
        <div class="card-header">
            <label>Company Selection</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-1">
                    <label for="CompanyMasterId" class="form-label">Company</label>
                    <select class="form-select" aria-label="Company" placeholder="Company" title="Company"
                        name="CompanyMasterId" [(ngModel)]="user.CompanyMasterId" #CompanyMasterId="ngModel" required>
                        <option disabled hidden [value]=null>--Select Company--</option>
                        <option *ngFor="let Company of Companys" [value]="Company.CompanyMasterId">
                            {{Company.CompanyName}}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                        Please select company.
                    </div>
                </div>

                <div class="col-md-12 px-1 pt-2">
                    <button type="submit" class="btn btn-primary w-100">
                        <i class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Continue':'Loading...'}}</button>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary me-1" (click)="close(false)" [disabled]="isDisabled"
                        ngbTooltip="Cancel" container="body" placement="top">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                </div>
            </div>
        </div>

    </div>
</form>